import React, { Component, useState, useEffect, useContext } from "react";
import axios from "axios";
import { Link } from 'react-router-dom';
import SglContext from '../SglContext';
import CheckoutPayment from './checkoutPayment';
import "./checkout.css";

import indicator_icon from "../images/Indicator.gif";

//API END POINTS
// const sgl_webservice_results = api_base_url+'/results';
// const sgl_webservice_iphone = Sgl.sglApiUrl+'/iphonev2/addentryv2/';
// const sgl_webservice_checkout = Sgl.sglApiUrl+'/iphonev2/checkoutv2/';

// const user_info_url = Sgl.nestApiUrl+'/users/getLoggedInUser';
// const sgl_webservice_iphone1 = webservice_url+'/iphone.php/webservice/';


class Checkout extends React.Component {
      
  get sgl_webservice_iphone() {
    return this.context.sglApiUrl + '/iphonev2/addentryv2/';
  }

  get sgl_webservice_checkout() {
    return this.context.sglApiUrl + '/iphonev2/checkoutv2/';
  }

  get user_info_url() {
    return this.context.nestApiUrl + '/users/getLoggedInUser';
  }

    state = {
      checkout_list: [],
      account_summary_checkout_list: [],
      selected_entries: [],
      payment_methods: [],
      bank_accounts: [],
      check_card_email_phone_info: false,
      check_address_info: false,
      include_all_shows: false,
      selected_entry_ids: [],
      current_show: localStorage.getItem('show_id'),
      div_type: "checkout",
      show_name:'',
      show_number: '',
      show_start_date:'',
      is_rider: false,
      check_payment_method_info: false,
      smc_payment: {},

      payment_error: '',
      payment_success: true,

      loading: true,
      switch_allowed: 0,
      switch_company_name: '',
      userData: {}

    }

    constructor() {
      super();
    //   this.PaginationElement = React.createRef();
    //   this.ShowPickerElement = React.createRef();
      this.CheckoutPaymentElement = React.createRef();

    //   this.checkout_paymentElement = React.createRef();
    //   this.onShowChange = this.onShowChange.bind(this);
      this.updateSelectedEntries = this.updateSelectedEntries.bind(this);
      this.updateCheckoutList = this.updateCheckoutList.bind(this);
      this.getPaymentMethods = this.getPaymentMethods.bind(this);
      this.showPaymentResults = this.showPaymentResults.bind(this);
      
      // bind function in constructor instead of render
      this.onChangePage = this.onChangePage.bind(this);
    }

    componentDidMount() {
      document.title = "Checkout";
      var switches = this.context.switches.switches;
      // switch_name: "Online Payments"
      var switch_found = switches.find(el => el.switch_name === "Online Payments");
      var switch_allowed = 0;
      if(switch_found){
        switch_allowed = switch_found.value;
      }
      this.setState({
        switch_allowed: switch_allowed
      });
      if(switch_allowed){
        this.getAllData();
      } else {
        this.setState({
          switch_allowed: switch_allowed,
          switch_company_name: this.context.switches.company_name?this.context.switches.company_name:'The Company',
          loading:false
        })
      }
      
    }

    getCheckoutData(include_all_shows, show){
        axios.get(this.sgl_webservice_checkout+'Index',{
          params : {
              includeAll : include_all_shows,
              show_id : show,
              customer_id: this.context.company_id,
              team_id: this.context.currentTeamId != 'personal'?this.context.currentTeamId:0,
          }
        }).then(res => {
          var entries = res.data.entries?res.data.entries:[];
          const entries_list = entries.map((entry) => {
            return {...entry, 'expanded': false};
          });
          this.setState({
            checkout_list: entries_list,
            current_show: res.data.show_id,
            show_name: res.data.show_name,
            show_number: res.data.show_number,
            show_start_date: res.data.start_date,
            is_rider: res.data.isRider,
            check_payment_method_info: res.data.check_payment_method_info,
            smc_payment: res.data.smc_payment? res.data.smc_payment: {},
            ach_enabled: res.data.ach_enabled,
            ach_service_fee_percent: res.data.ach_service_fee_percent,
            ach_service_fee_cap: res.data.ach_service_fee_cap,
            bank_accounts: res.data.bank_accounts,
            include_all_shows: include_all_shows,
            selected_entries: []
          });
          if(!include_all_shows){
            this.setState({
              account_summary_checkout_list: entries_list,
            });
          }
          document.getElementById('include-all-please-wait').style.display = "none ";

      })
      
    }
    
    getAllData(){   
      this.getUserData();
   
      axios.all([
        axios.get(this.sgl_webservice_iphone+'GetPaymentMethods',{
            params : {
              company_id: this.context.company_id,
              team_id: this.context.currentTeamId != 'personal'?this.context.currentTeamId:0,
            }
          })
        
      ]).then(axios.spread((paymentMethods) => {
        this.context.reportToGA('/sgl-wp-plugin/' + this.context.company_urlpath+'/checkout');
        this.context.reportToFB('/sgl-wp-plugin/' + this.context.company_urlpath+'/checkout');

        this.setState({
          payment_methods: paymentMethods.data.payment_methods?paymentMethods.data.payment_methods:[],
          can_checkout: paymentMethods.data.can_checkout,
          bank_accounts: paymentMethods.data.bank_accounts?paymentMethods.data.bank_accounts:[],
          check_card_email_phone_info: paymentMethods.data.check_card_email_phone_info,
          check_address_info: paymentMethods.data.check_address_info,
          loading: false
        })    
        
        this.getCheckoutData(this.state.include_all_shows, this.state.current_show);
        
      })) 
      
    }
    getPaymentMethods(){
      axios.get(this.sgl_webservice_iphone+'GetPaymentMethods',{
        params : {
            company_id: this.context.company_id,
            team_id: this.context.currentTeamId != 'personal'?this.context.currentTeamId:0,
        }
      }).then(results => {
        this.setState({
          payment_methods: results.data.payment_methods,
          can_checkout: results.data.can_checkout,
          bank_accounts: results.data.bank_accounts,
          check_card_email_phone_info: results.data.check_card_email_phone_info,
          check_address_info: results.data.check_address_info,
          loading: false
        })    
      })
    }

    onChangePage(page) {
      this.getCheckoutData(this.state.include_all_shows, this.state.current_show);
    }

    // onShowChange(show_id) {
    //   localStorage.setItem('show_id', show_id);
    //   this.getCheckoutData(this.state.include_all_shows, show_id);
    // }
    componentDidUpdate(prevProps){
        if(prevProps.current_show !== this.props.current_show){
            var show_id = this.props.current_show;
            this.getCheckoutData(this.state.include_all_shows, show_id);
            this.setState({
                current_show: show_id,
            });
            
        }
    }

    openTab = (tabName) => (e) => {
      var i, tabcontent, tablinks;
      tabcontent = document.getElementsByClassName("tabcontent");
      for (i = 0; i < tabcontent.length; i++) {
        tabcontent[i].style.display = "none";
      }

      tablinks = document.getElementsByClassName("tablinks");
      for (i = 0; i < tablinks.length; i++) {
        tablinks[i].className = tablinks[i].className.replace(" active", "");
      }

      document.getElementById(tabName).style.display = "block";
      e.currentTarget.className += " active";
    //   this.getResultsData(tabName, this.state.current_show);
    }
    updateIncludeAll(e) {
      document.getElementById('include-all-please-wait').style.display = "block";
      
      this.getCheckoutData(e.target.checked, this.state.current_show);

      
    }
    updateSelectedEntries(entries_list){
      this.setState({ selected_entries:  entries_list});
    }
    updateCheckoutList(entries_list){
      this.setState({ checkout_list:  entries_list});
    }
    updateSummaryCheckoutList(entries_list){
      this.setState({ account_summary_checkout_list:  entries_list});
    }
    // format_time(timeString){
    //   var H = +timeString.substr(0, 2);
    //   var h = H % 12 || 12;
    //   var ampm = (H < 12 || H === 24) ? " AM" : " PM";
    //   timeString = h + timeString.substr(2, 3) + ampm;
    //   return timeString;
    // }
    getDefaultTab(tab){
      if(this.state.div_type === tab){
        return ' active';
      }
      return '';
    }
    getUserData(){
      axios.get(this.user_info_url)
      .then((response) => {
        this.context.checkLoginOnSGL();
        if(response.data.user && response.data.user != null){
          this.setState({
            userData : response.data.user,
          });
        }else{
        }
      }, (error) => {
      });
    }
    format_currancy(amount){
      if(amount === 0){
        return '$0.00';
      }
      if(amount === undefined || amount === ''){
        return '';
      }
      return '$'+(amount && Number(amount).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','));

    }
    getPaymentDescription(){
      var desc = this.state.show_number;
      if (!this.state.show_start_date || this.state.show_start_date === '0000-00-00'){
          desc = desc;
      } else {
        var formatted_date = (new Date(this.state.show_start_date));
        var year = formatted_date.getFullYear().toString().substr(-2);
        desc = desc + '-' + year;
      }
      this.state.selected_entries.forEach(entry => {
        desc = desc + ' ' + entry.number;
      });
      return desc;
      
    }
    getTotalBalance(){
      let sum = this.state.checkout_list.reduce(function(prev, current) {
          return prev + +current['balance']
        }, 0);
        return sum;
    }
    getSummaryTotalBalance(){
      let sum = this.state.account_summary_checkout_list.reduce(function(prev, current) {
          return prev + +current['balance']
        }, 0);
        return sum;
    }
    setArrow(expanded){
      let className = 'direction';

      className += (expanded) ? ' asc' : ' desc';
      return className;
    }

    handleExpandClick = (entry) => (e) => {
          var expanded = entry.expanded?false:true;

          var entries_list = this.state.checkout_list;
          entries_list = entries_list.map(el => (el.entry_id === entry.entry_id ? { ...el, expanded } : el)) ;
          this.updateCheckoutList(entries_list);
  
    }
    handleSummaryExpandClick = (entry) => (e) => {
      var expanded = entry.expanded?false:true;

      var entries_list = this.state.account_summary_checkout_list;
      entries_list = entries_list.map(el => (el.entry_id === entry.entry_id ? { ...el, expanded } : el)) ;
      this.updateSummaryCheckoutList(entries_list);

    }
    

    //////////// submit payments ///////////////

    showPaymentResults(results){
        document.getElementById('payment_result').style.display = "block";
        document.getElementById('payment_details').style.display = "none";
        var div = document.createElement("div");
        div.innerHTML = results.error;
        var error = div.textContent || div.innerText || "";
        this.setState({payment_error: error, payment_success: results.success}); 
        this.updateSelectedEntries([]);
    }

    backToCheckout = () => (e) => {
      document.getElementById('payment_result').style.display = "none";
      document.getElementById('payment_details').style.display = "block";
      this.setState({payment_error: '', payment_success: true});
      this.getCheckoutData(this.state.include_all_shows, this.state.current_show);
    }
    //////////// end saving payment functions ///////////////

    render(){
      const loading = this.state.loading;
      if(loading) {
        return null;
      }
      if(this.state.switch_allowed != 1){
        return(
          <div>
            <h2>Checkout</h2>
            <p>{this.state.switch_company_name + ' does not support this feature.'}</p>
          </div>
        )
      }
      return(
        <div className="sgl-plugin checkout_page">
            <h2>Checkout - {this.state.show_name}</h2>
            <div className='credit-text'> {process.env.REACT_APP_CREDIT_TEXT}{" "} <a onClick={() => window.open(`https://www.showgroundslive.com`, '_blank', 'noopener,noreferrer')}> {process.env.REACT_APP_CREDIT_COMPANY} </a> </div><br />
            <div className="section-tab tab">
                <button className={["tablinks", this.getDefaultTab('account_summary')].join(' ')} onClick={this.openTab('account_summary')}>Account Summary</button>
                <button className={["tablinks", this.getDefaultTab('checkout')].join(' ')} onClick={this.openTab('checkout')}>Checkout</button>
            </div>

            <div id="account_summary"  className="tabcontent display_none">
            
                <div>
                  
                    <div style={{overflowX: "auto"}}> 
                      { (this.state.account_summary_checkout_list.length > 0) ?
                        <table  style={{width: "100%"}} className="table table-striped table-hover">
                            <tbody>
                                <tr className="sgl-primary-header">
                                  <th className="display_on_mobile">Entries</th>
                                  <th className="display_on_desktop">Entry</th>
                                  <th className="display_on_desktop">Horse</th>
                                  <th className="display_on_desktop">Riders</th>
                                  <th className="display_on_desktop">Owner</th>
                                  <th className="right-align">Balance</th>
                                  <th></th>
                                </tr>
                            {/* </thead> */}
                            {/* <tbody> */}
                                {this.state.account_summary_checkout_list.map((data, index) => {
                                    return [
                                      <tr>
                                        <td className="display_on_mobile mbl_custom_row new-line">
                                          <p className="table_row_p">
                                            <span><strong>Entry:</strong><strong><Link to ={'/entries/detail?eid='+data.entry_id+'&sid='+this.state.current_show}>{data.number}</Link></strong></span>
                                            <br></br>
                                            <span><strong>Horse:</strong> <Link to={'/entries/detail?eid='+data.entry_id+'&sid='+this.state.current_show}>{data.horse?data.horse:'N/A'} {data.trainer_account?data.app_trainer_account_text:''}</Link></span>
                                            <br></br>
                                            <span><strong>Riders:</strong> {data.rider_list} <span className='show_name'>{this.state.include_all_shows?'\n Show: '+data.show_name:''}</span></span>
                                            <br></br>
                                            <span><strong>Owner:</strong> <Link to={'/people/detail?pid='+data.entryowner_id+'&sid='+this.state.current_show}>{data.owner}</Link></span>
                                          </p>
                                        </td>
                                        <td className="centerCheckBox display_on_desktop"><strong><Link to={'/entries/detail?eid='+data.entry_id+'&sid='+this.state.current_show}>{data.number}</Link></strong></td>
                                        <td className="centerCheckBox display_on_desktop"><Link to={'/entries/detail?eid='+data.entry_id+'&sid='+this.state.current_show}>{data.horse?data.horse:'N/A'} {data.trainer_account?data.app_trainer_account_text:''}</Link></td>
                                        <td className="centerCheckBox display_on_desktop new-line">{data.rider_list} <span className='show_name'>{this.state.include_all_shows?'\n Show: '+data.show_name:''}</span></td>
                                        <td className="centerCheckBox display_on_desktop"><Link to={'/people/detail?pid='+data.entryowner_id+'&sid='+this.state.current_show}>{data.owner}</Link></td>
                                        <td className="centerCheckBox right-align">{this.format_currancy(data.balance)}</td>
                                        <td className="centerCheckBox center-align" onClick={ this.handleSummaryExpandClick(data)}>
                                            <div className='ring-arrow sgl-arrow' >
                                                <span className={this.setArrow(data.expanded)}></span>
                                            </div>
                                        </td>
                                      
                                      </tr>,
                                        <tr className={data.expanded?'':'display_none'}>
                                            <td colSpan="3" className="display_on_desktop"></td>
                                            <td className="right-align">
                                                    
                                                 <p className="entry-detail-p">
                                                    <span>Class Fee:</span>
                                                    <br></br>
                                                    <span>Misc. Fee:</span>
                                                    <br></br>
                                                    <span>Tax:</span>
                                                    <br></br>
                                                    <span><strong>Subtotal:</strong></span>
                                                    <br></br>
                                                    <span>Payments:</span>
                                                    <br></br>
                                                    <span><strong>Balance:</strong></span>
                                                </p>
                                            </td>
                                            <td  className="right-align">
                                                <p className="entry-detail-p">
                                                    <span>{this.format_currancy(data.class_amount)}</span>
                                                    <br></br>
                                                    <span>{this.format_currancy(data.misc_amount)}</span>
                                                    <br></br>
                                                    <span>{this.format_currancy(data.tax)}</span>
                                                    <br></br>
                                                    <span>{this.format_currancy(data.class_amount+data.misc_amount+Number(data.tax))}</span>
                                                    <br></br>
                                                    <span>{this.format_currancy(data.total_paid)}</span>
                                                    <br></br>
                                                    <span>{this.format_currancy(data.balance)}</span>
                                                </p>
                                                
                                            </td>
                                            <td></td>
                                        </tr>
                                    ]
                                  })
                                
                                }
                                <tr>
                                  <td colSpan="6" className="td-style"> <div className="total"><span>Total</span><strong>{this.format_currancy(this.getTotalBalance())}</strong> </div></td>                                        
                                </tr>
                            </tbody>
                        </table>
                      :
                          <p> No Entries Found </p>

                      }
                    </div>
                      
                </div>
                
            </div>
            <br />
            <div id="checkout"  className="tabcontent display_block">
              {
                (!this.state.can_checkout)?
                <div className='required'>You cannot checkout entries for this team.</div>
                :
              <div id='payment_details'>
                <div className='right-checkbox'>
                  <span id="include-all-please-wait" className='left display_none'><img src={indicator_icon} /></span>
                  <input type="checkbox" name="selectEntry" id="include_all" onChange={e => this.updateIncludeAll(e)}/>
                  <label for='include_all' id="include_all_label">  All Past Due</label>
                </div>
                { (this.state.checkout_list.length > 0) ?
                  <p><strong>Select the entries you would like to Checkout by checking off the boxes to the left.</strong> {this.state.include_all_shows}</p>
                :
                  <p>You have no entries with outstanding balance.</p>
                }
                { (this.state.checkout_list.length > 0) &&
                  <CheckoutPayment 
                    selected_entries = {this.state.selected_entries} 
                    checkout_list = {this.state.checkout_list} 
                    updateSelectedEntries = {this.updateSelectedEntries} 
                    updateCheckoutList = {this.updateCheckoutList}
                    include_all_shows = {this.state.include_all_shows} 
                    payment_methods = {this.state.payment_methods} 
                    check_card_email_phone_info = {this.state.check_card_email_phone_info} 
                    check_address_info = {this.state.check_address_info}
                    payment_description = {this.getPaymentDescription()}
                    getPaymentMethods = {this.getPaymentMethods}
                    can_checkout = {this.state.can_checkout}
                    ach_enabled = {this.state.ach_enabled}
                    ach_service_fee_percent = {this.state.ach_service_fee_percent}
                    ach_service_fee_cap = {this.state.ach_service_fee_cap}
                    bank_accounts = {this.state.bank_accounts}
                    smc_payment = {this.state.smc_payment}
                    current_show = {this.state.current_show}
                    showPaymentResults = {this.showPaymentResults}
                    check_payment_method_info = {this.state.check_payment_method_info}
                    ref = {this.CheckoutPaymentElement}
                  />

                }
              </div>
              }
              <div id='payment_result' className='display_none'>
                {(this.state.payment_success) ? 
                    <p>Thank you! Payment has been submitted successfully.</p>
                :
                    <p>Transaction Declined: {this.state.payment_error}</p>
                }
                <button className='sgl-button' onClick={this.backToCheckout()}>
                    Back to Checkout
                </button>
              </div>
            </div>
            <div className="copyright-text">{process.env.REACT_APP_COPYRIGHT_TEXT}</div>
        </div>
      )
    }
  }
// ReactDOM.render(<Checkout />, document.getElementById("sgl-content-wrapper"));
Checkout.contextType = SglContext;

export default Checkout;